import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CustomStoryCard2 from "../../molecules/CustomStoryCard2";
import { getSlug, getCollectionName } from "../../utils/utils";

import "./nineStories.m.css";

const NineStories = ({ collection, sections, domainSlug }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(global.deviceWidth <= 876);
  }, []);

  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const stories = collection.items.filter((item) => item.type === "story");
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const firstStory = stories.length > 0 ? stories[0] : null;

  return (
    <div styleName="base" className="nine-stories" data-testid="nine-stories-cards">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionSlug={collectionSlug}
          collectionName={collectionName}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div className="nine-stories">
        {stories.length > 1 && <Organism1 stories={stories.slice(1, 5)} className="left-storycards" />}
        {firstStory && (
          <CustomStoryCard2
            story={firstStory.story}
            imageType={isMobile ? "image16x9" : "image4x3"}
            aspectRatio={isMobile ? [16, 9] : [4, 3]}
            headlineType={25}
            isImageCaptionRequired={false}
            isSection={false}
            widths={[380]}
            isExcerpt={true}
            className="first-story"
            updatedFont={true}
            src="nine-stories"
            updateSubHeadline={true}
          />
        )}
        {stories.length > 5 && <Organism1 stories={stories.slice(5, 9)} className="right-storycards" />}
      </div>
    </div>
  );
};

NineStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

NineStories.storyLimit = 9;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(NineStories);
